import { Component, OnInit } from "@angular/core";
import { FormField } from "../../../interfaces/form-field.model";
import { faPrint, faEraser } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "@angular/common";
import { NotifierService } from "angular-notifier";
import { COEStockByDateReportService } from "src/app/services/autopac-reports/coe-stock-by-date-report.service";

@Component({
  selector: "coe-stock-by-date-report",
  templateUrl: "./coe-stock-by-date-report.component.html",
  styleUrls: ["./coe-stock-by-date-report.component.css"],
})
export class COEStockByDateReportComponent implements OnInit {
  faPrint = faPrint;

  lockBtn = true;

  form!: FormField[];

  constructor(
    private notifier: NotifierService,
    private COEStockByDateReportService: COEStockByDateReportService,
  ) {}

  updateFields(event: any): void {
    this.form = event.fields;
    if (
      this.getFieldValue("StockAsOn")
    ) {
      this.lockBtn = false;
    } else {
      this.lockBtn = true;
    }
  }

  ngOnInit() {
    this.setUpFormFields();
  }

  private setUpFormFields(): void {
    this.form = [
      {
        type: "radio",
        id: "type",
        label: "Report Type",
        options: [
          {
            display: "Actual COE Stock",
            value: "ActualCOEStock",
          },
          {
            display: "Stock Less Taken By",
            value: "StockLessTakenBy",
          },
        ],
        value: "ActualCOEStock",
        required: true,
      },
      {
        type: "date",
        id: "StockAsOn",
        label: "Stock At (dd/mm/yyyy)",
        required: true,
      },
      {
        type: "select",
        id: "Format",
        label: "Select Format",
        options: [
          {
            value: "pdf",
            display: "PDF",
          },
          {
            value: "excel",
            display: "EXCEL",
          },
          {
            value: "both",
            display: "BOTH",
          },
        ],
        value: "pdf",
      },
    ];
  }

  printStatus(): void {
    const searchData = this.populateSearchBody();
    this.COEStockByDateReportService.COEStockByDateReport(searchData).subscribe(
      {
        next: (response) => {
          if (this.getFieldValue("Format") == "pdf") {
            window.open(response.body.Name, "_blank");
          } else if (this.getFieldValue("Format") == "excel") {
            window.open(response.body.Value, "_blank");
          } else if (this.getFieldValue("Format") == "both") {
            window.open(response.body.Value, "_blank");
            window.open(response.body.Name, "_blank");
          }
        },
        error: (error) => {
          console.log(error);
          this.handleError("Error getting data", error);
        },
      },
    );
  }

  private populateSearchBody(): any {
    return {
      StockAsOn: formatDate(
        this.getFieldValue("StockAsOn"),
        "dd/MM/yyyy",
        "en-US",
      ),
      Type: this.getFieldValue("type"),
    };
  }

  private getFieldValue(id: string, index?: number): any {
    const field = this.form.find((f) => f.id === id);
    return index !== undefined ? field?.value[index] : field?.value;
  }

  private handleError(message: string, error: any): void {
    console.error(message, error);
    this.notifier.notify("error", message);
  }
}
